import React from "react";
import ReactDOM from "react-dom";
import {getParameterByName} from "../../../utils";
import "bootstrap/js/src/modal";
import DataLayerService from "datalayer-service";
import {OnlinePromoAction, OnlinePromoEngagementType, PromoType} from "datalayer-service/src/types/enums";

const placeholder = document.createElement("div");
const dataLayerService = new DataLayerService(window);

class OnlinePromoModalBoxComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: {slug: "", name: ""},
            promotion: {code: "", link_only: false, retailer: {}},
            codeCopied: false,
            showCopyNotSupported: false,
            copySupported: props.copySupported,
        };
        this.modal = React.createRef();

        this.dismiss = this.dismiss.bind(this);
        this.handleCopy = this.handleCopy.bind(this);
    }

    componentDidMount() {
        const base = `/api/v2/promos/mattress-deals/`;
        const extraParams = this.props.isBrandPromo
            ? `is_bp=${this.props.isBrandPromo}`
            : `classname=${this.props.classname}&slug=${this.props.slug}`;
        const url = `${base}${this.props.offer}/?${extraParams}`;

        $.get(url, (result) => {
            this.setState({
                product: result,
                promotion: result.extra_data.promotion,
            });
            $(this.modal.current).modal();
          this.trackPromoRevealEvent();
        });

        if (
            window.history !== undefined &&
            typeof window.history.pushState === "function"
        ) {
            history.pushState(null, "", location.href.split("?")[0]);
            window.scrollTo(0, this.props.scrollY);
        }
    }

  trackPromoRevealEvent() {

    let engagementType;
    switch (this.props.classname) {
      case 'store':
      case 'retailer':
        engagementType = OnlinePromoEngagementType.RETAILER;
        break;
      case 'mattress':
      case 'mattresscollection':
      case 'collection':
      case 'line':
      case 'manufacturer':
        engagementType = OnlinePromoEngagementType.PRODUCT;
        break;
      default:
        engagementType = "";
    }

    dataLayerService.onlinePromotionInteractionEvent({
      action: OnlinePromoAction.PROMO_REVEAL,
      retailer: this.state.promotion.retailer.slug,
      engagementType: engagementType,
      type: PromoType.ONLINE,
    });

  }

  dismiss() {
        $(this.modal.current).modal("hide");
        ReactDOM.unmountComponentAtNode(placeholder);
    }

    handleCopy(event) {
        event.preventDefault();
        $(event.target).select();

        if (this.state.copySupported) {
            try {
                var copied = document.execCommand("copy");
                if (copied) {
                    this.setState({codeCopied: true});
                } else {
                    this.setState({
                        codeCopied: false,
                        showCopyNotSupported: true,
                    });
                }
            } catch (err) {
            }
        }
    }

    render() {
        return (
            <div
                data-promo-code-reveal={this.state.promotion.id}
                className="modal hide fade promo-code-reveal"
                ref={this.modal}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <header className="modal-header text-left">
                            <img
                                src={this.state.promotion.retailer.logo}
                                alt={this.state.product.name + " logo"}
                            />

                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={this.dismiss}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </header>

                        <section className="modal-body text-center">
                            {this.state.promotion.link_only ? (
                                <>
                                    <div className="d-flex justify-content-center">
                                        <a
                                            className="claim-discount-link-btn"
                                            href={
                                                this.state.promotion
                                                    .outbound_url
                                            }
                                            target="_blank"
                                            rel="nofollow"
                                        >
                                            Claim this discount
                                        </a>
                                    </div>
                                    <h4 className="modal-title mb-3">
                                        Click the button above to activate
                                        this discount on the{" "}
                                        <a
                                            href={
                                                this.state.promotion
                                                    .outbound_url
                                            }
                                            target="_blank"
                                            rel="nofollow"
                                        >
                                            {
                                                this.state.promotion
                                                    .external_domain
                                            }
                                        </a>
                                        . This discount will be applied
                                        automatically at checkout (no promo
                                        code needed).
                                    </h4>
                                </>
                            ) : (
                                <>
                                    <div className="box discount">
                                        <h5 className="mb-0">
                                            <input
                                                id={
                                                    this.state.product
                                                        .slug + "-promo"
                                                }
                                                data-promo-input="true"
                                                value={
                                                    this.state.promotion
                                                        .code
                                                }
                                                onMouseDown={
                                                    this.handleCopy
                                                }
                                                readOnly
                                            />
                                        </h5>
                                    </div>
                                    <h4 className="modal-title mb-3">
                                            <span
                                                className={
                                                    this.state.codeCopied
                                                        ? "d-block-inline"
                                                        : "d-none"
                                                }
                                            >
                                                The code has been copied. Go
                                                to&nbsp;
                                            </span>
                                        <span
                                            className={
                                                this.state
                                                    .showCopyNotSupported
                                                    ? "d-block-inline"
                                                    : "d-none"
                                            }
                                        >
                                                Your browser doesn't support
                                                this action.
                                                <br/>
                                                Please copy the code above, then
                                                go to&nbsp;
                                            </span>
                                        <span
                                            className={
                                                this.state.codeCopied
                                                    ? "d-none"
                                                    : "d-block-inline"
                                            }
                                        >
                                                <span
                                                    className={
                                                        this.state.copySupported
                                                            ? "d-none"
                                                            : "d-block"
                                                    }
                                                >
                                                    Copy the code above,
                                                </span>
                                                <span
                                                    className={
                                                        this.state.copySupported
                                                            ? "d-block"
                                                            : "d-none"
                                                    }
                                                >
                                                    Click the code above to copy
                                                    it,
                                                </span>
                                                then go to&nbsp;
                                            </span>
                                        <a
                                            href={
                                                this.state.promotion
                                                    .outbound_url
                                            }
                                            target="_blank"
                                            rel="nofollow"
                                        >
                                            <b>
                                                {
                                                    this.state.promotion
                                                        .external_domain
                                                }
                                            </b>
                                        </a>{" "}
                                        and enter this code at checkout.
                                    </h4>
                                </>
                            )}

                            <div
                                className={
                                    "box box-gray mt-4 text-sm " +
                                    (this.state.promotion.reward_description
                                        ? "d-block"
                                        : "d-none")
                                }
                            >
                                Get{" "}
                                {this.state.promotion.reward_description}
                            </div>
                        </section>

                        <footer className="modal-footer justify-content-center">
                            <button
                                type="button"
                                className="btn btn-default btn-lg center-block"
                                onClick={this.dismiss}
                                data-dismiss="modal"
                            >
                                <b>Close</b>
                            </button>
                        </footer>
                    </div>
                </div>
            </div>
        );
    }
}

export function promoBoxTrigger() {
    // On startup, check if the coupon should be opened
    const showOffer = getParameterByName("show-promo-code");
    const slug = getParameterByName("slug");
    const classname = getParameterByName("classname");
    const isBrandPromo = getParameterByName("is_bp") || false;
    const scrollY = getParameterByName("scrollY");

    if (showOffer !== undefined && ((slug && classname) || isBrandPromo)) {
        const copySupported = is_copy_operation_supported();
        document.body.appendChild(placeholder);
        ReactDOM.render(
            <OnlinePromoModalBoxComponent
                offer={showOffer}
                slug={slug}
                classname={classname}
                isBrandPromo={isBrandPromo}
                scrollY={scrollY}
                copySupported={copySupported}
            />,
            placeholder
        );
    }
}

function is_copy_operation_supported() {
    let is_copy_supported = false;
    if (window.document.queryCommandSupported === undefined) {
        is_copy_supported = false;
    } else {
        is_copy_supported = window.document.queryCommandSupported("copy");
    }

    return is_copy_supported;
}
